import React from 'react';
// Constants
import { LOYALFANS_URL } from '../../utils/Constants';
// Data
import { smallFanSitesArray } from '../../utils/data/FansiteData';

function VisitMyPaySites() {
  return (
    <section className='grid'>
      <div className='grid lg:grid-cols-[1fr_2fr] lg:container lg:mx-auto gap-y-4 gap-x-6 px-6 sm:px-10 xl:gap-x-10 md:px-16 lg:px-10'>
        {/* Image */}
        <div className='grid md:grid-cols-2 gap-y-6 md:gap-2 pb-8'>
          {smallFanSitesArray.map((site, index) => (
            <a
              key={index}
              href={site.url}
              target='_blank'
              rel='noopener noreferrer'
              className='px-6 rounded-lg transition-transform transform hover:scale-105'
            >
              {site.logo && !site.icon ? (
                <img
                  src={site.logo}
                  alt={`${site.name} Logo`}
                  className='h-16 brightness-125 mx-auto'
                  loading='lazy'
                />
              ) : site.icon && site.logo ? (
                <div className='flex items-center justify-center gap-3'>
                  {/* Check if site.icon is a string or a React icon */}
                  {typeof site.icon === 'string' ? (
                    <img
                      src={site.icon}
                      alt={`${site.name} Icon`}
                      className='h-10'
                      loading='lazy'
                    />
                  ) : (
                    <span className='text-4xl text-colour1'>{site.icon}</span>
                  )}
                  <img
                    src={site.logo}
                    alt={`${site.name} Logo`}
                    className='h-16 brightness-125'
                    loading='lazy'
                  />
                </div>
              ) : site.icon && site.textOnly ? (
                // Special case: Telegram (Icon + Text)
                <div className='grid w-fit gap-4 justify-center mx-auto grid-flow-col items-center'>
                  <div>
                    {/* Check if site.icon is a string or a React icon */}
                    {typeof site.icon === 'string' ? (
                      <img
                        src={site.icon}
                        alt={`${site.name} Icon`}
                        className='h-10'
                        loading='lazy'
                      />
                    ) : (
                      <span className='text-4xl text-colour1'>{site.icon}</span>
                    )}
                  </div>
                  <div>
                    <span className='text-2xl lg:text-4xl uppercase text-center mt-2 text-colour1 font-semibold'>
                      {site.name}
                    </span>
                  </div>
                </div>
              ) : site.icon ? (
                <div className='grid justify-center h-fit'>
                  {/* Check if site.icon is a string or a React icon */}
                  {typeof site.icon === 'string' ? (
                    <img
                      src={site.icon}
                      alt={`${site.name} Icon`}
                      className='h-10'
                      loading='lazy'
                    />
                  ) : (
                    <span className='text-4xl text-colour8'>{site.icon}</span>
                  )}
                </div>
              ) : (
                <div className='text-center text-colour1 uppercase text-4xl font-bold'>
                  {site.name}
                </div>
              )}
              <div className='text-center'>
                <p className='text-2xl font-titleFont'>{site.name}</p>
              </div>
            </a>
          ))}
        </div>

        {/* Article */}
        <article className='grid gap-4 pt-2'>
          {/* Header */}
          <section className='grid grid-cols-reg w-full gap-x-6'>
            {/* Large screen */}
            <div className='hidden md:grid items-center'>
              <h3 className='text-3xl text-colour7 font-titleFont tracking-widest'>
                Join My Exclusive Pages
              </h3>
            </div>
            {/* Phone screen */}
            <div className='grid md:hidden items-center'>
              <h3 className='text-2xl text-colour7 font-titleFont tracking-widest'>
                Join My <br /> Exclusive Pages
              </h3>
            </div>
            <div className='grid items-center'>
              <div
                className='h-[2px] -mb-1 bg-colour7'
                role='separator'
                aria-hidden='true'
              ></div>
            </div>
          </section>

          {/* Main Content */}
          <section className='grid gap-2 text-center lg:text-left text-sm'>
            <p>
              <strong>Join My LOYALFANS</strong> page for exclusive photos,
              videos, blogs, live streams, and MUCH more!
            </p>

            <p>
              Want to see even more photos of Me? I post{' '}
              <strong>
                exclusive photos, videos, and voice recordings daily
              </strong>{' '}
              on My LoyalFans.{' '}
              <a
                href={LOYALFANS_URL}
                target='_blank'
                rel='noreferrer'
                className='text-colour1 font-bold underline hover:text-opacity-75 transition'
              >
                Click Here
              </a>{' '}
              to join!
            </p>
          </section>
        </article>
      </div>
    </section>
  );
}

export default VisitMyPaySites;
